import { z } from 'zod';
import type { ZodTypeAny } from 'zod';

import type { FlexibleDoublePicksFieldType } from './types';

const slateConfigSchema = z.object({
  id: z.string(),
  slateId: z.string().min(1, 'Slate is required'),
  percentage: z
    .number()
    .min(0, 'Percentage must be positive')
    .max(100, 'Percentage cannot exceed 100%')
    .nullable(),
});

export const createValidationSchema = (field: FlexibleDoublePicksFieldType) => {
  let fieldSchema: ZodTypeAny = z
    .object({
      enabled: z.boolean(),
      slates: z.array(slateConfigSchema),
    })
    .refine(
      (data) => {
        if (data.enabled) {
          if (!data.slates || data.slates.length === 0) {
            return false;
          }
          const hasValidSlate = data.slates.some((slate) => slate.slateId && !!slate.percentage);
          return hasValidSlate;
        }
        return true;
      },
      {
        message:
          'Please configure at least one slate with a percentage when flexible double picks is enabled.',
        path: ['slates'],
      }
    );

  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};
